import React from 'react';
import { Helmet } from 'react-helmet-async';
import LandingHeroEditorial from '../components/landing/LandingHeroEditorial';
import LandingProductsSection from '../components/landing/LandingProductsSection';
import ProcessSection from '../components/landing/ProcessSection';
import IdealForBusinessSection from '../components/landing/IdealForBusinessSection';
import SmallBusinessSolutionSection from '../components/landing/SmallBusinessSolutionSection';
import LandingQuoteSection from '../components/landing/LandingQuoteSection';
import LandingFaqSection from '../components/landing/LandingFaqSection';
import NewsletterSection from '../components/landing/NewsletterSection';
import { getSiteUrl } from '../config/site';
import LandingMobileCta from '../components/landing/LandingMobileCta';

/** فیلتر ثابت صفحه اصلی — از localStorage صفحهٔ «خدمات» استفاده نمی‌شود تا ویترین همیشه «کل ایران» بماند */
const HOME_SERVICES_FILTERS = Object.freeze({
  search: '',
  city: 'کل ایران',
  serviceType: 'all',
  rating: 'all',
  history: 'all'
});

const Home = () => {
  const site = getSiteUrl();
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Flasher",
    "description": "فلاشر؛ بازار آنلاین B2B برای معرفی محصولات صنعتی و صنفی، اتصال خریدار به تولیدکننده و رشد فروش",
    "url": site,
    "logo": `${site}/logo.png`,
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+98-21-1234567",
      "contactType": "customer service",
      "areaServed": "IR",
      "availableLanguage": ["Persian", "English"]
    },
    "sameAs": [
      "https://instagram.com/flasher.ir",
      "https://linkedin.com/company/flasher",
      "https://twitter.com/flasher_ir"
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "تهران، ایران",
      "addressLocality": "تهران",
      "addressCountry": "IR"
    },
    "offers": {
      "@type": "AggregateOffer",
      "description": "محصولات کسب و کار ",
      "priceCurrency": "IRR"
    }
  };

  return (
    <>
      <Helmet>
        <title>فلاشر | بازار B2B محصولات صنعتی و صنفی</title>
        <meta name="description" content="فلاشر تولیدکننده و صاحب صنف را سریع به خریدار جدی وصل می‌کند: ویترین حرفه‌ای، جستجو بر اساس شهر و صنف، و مسیر تماس شفاف—برای فروشی که در یک فلاش دیده می‌شود." />
        <meta name="keywords" content="فلاشر, Flasher, B2B, بازار عمده, محصول صنعتی, اصناف, تولیدکننده, فروش آنلاین" />
        <meta name="author" content="Flasher" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="fa-IR" />
        <meta name="geo.region" content="IR" />
        <meta name="geo.placename" content="Iran" />
        <meta property="og:title" content="فلاشر — از کارگاه تا مشتری واقعی" />
        <meta property="og:description" content="بازار B2B برای معرفی محصول، فیلتر شهر و صنف، و ارتباط مستقیم با خریداران جدی." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={site} />
        <meta property="og:image" content={`${site}/og-image-home.jpg`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Flasher" />
        <meta property="og:locale" content="fa_IR" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="فلاشر | بازار B2B محصولات" />
        <meta name="twitter:description" content="در یک فلاش دیده شو؛ جستجو بر اساس شهر و صنف، تماس مستقیم با خریدار." />
        <meta name="twitter:image" content={`${site}/og-image-home.jpg`} />
        <meta name="twitter:site" content="@flasher_ir" />
        <link rel="canonical" href={site} />
        <meta name="theme-color" content="#714b67" />
        <meta name="msapplication-TileColor" content="#714b67" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <div className="landing-editorial bg-linen-canvas pb-[5.75rem] md:pb-0">
        <LandingHeroEditorial />
        <LandingProductsSection searchParams={HOME_SERVICES_FILTERS} />
        <ProcessSection />
        <IdealForBusinessSection />
        <SmallBusinessSolutionSection />
        <LandingQuoteSection />
        <LandingFaqSection />
        <NewsletterSection />
      </div>
      <LandingMobileCta />
    </>
  );
};

export default Home;
